import React from 'react';
import Page from '../components/Inclusion/Page';
import '../assets/css/little_wallet_new.css';


const ConfirmInclusion = () => {

    return (
        <div>
            <Page />
        </div>
    );
};

export default ConfirmInclusion;


/** WEBPACK FOOTER **
 ** ./src/containers/ConfirmInclusion.js
 **/